import { SDK_ENROLLMENT } from '../../mock/fixtures/sdk'
import { dispatchLoaderEvent } from '../../utils/loader'
import { EnrollmentRouteLoader } from './enrollment-route.types'

export const enrollmentRouteLoader: EnrollmentRouteLoader = () => {
  dispatchLoaderEvent({ showLoader: false })
  return Promise.resolve(SDK_ENROLLMENT)
}
